import React from 'react';
import { Route } from 'react-router-dom';
import * as routes from '../../../universal/main/mainRoutes';
import MainController from './controllers/MainController';
import NamesPagesController from './controllers/NamesPagesController';

export function createMainRoutes() {
  return [
    <MainController key="obnoarding" />,
    <Route exact key="namesLists" path={routes.NAMESLIST} component={NamesPagesController} />
  ];
}
